import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import { styled } from 'styletron-react';
import { staticColors } from '../../../../const/colors/staticColors';
import { sizes } from '../../../../const/sizes';
export const RadioDonutIndicator = styled(RadixRadioGroup.Indicator, (p) => ({
    width: sizes.radio.donutSize,
    height: sizes.radio.donutSize,
    borderRadius: '50%',
    backgroundColor: p.$isDisabled
        ? staticColors.radioUnchecked
        : staticColors.radioChecked,
}));
